// Import all images
import IvanLogo from "./IvanLogo.png";
import afterRepair from "./afterRepair.jpg";
import beforeRepair from "./beforeRepair.jpg";
import maintenance from "./maintenance.jpg";
import maintenance2 from "./maintenance2.jpg";
import business from "./business.jpg";
import emergency from "./emergency.jpg";
import aboutIvan from "./aboutIvan.png";
import Installation from "./installation.jpg";
import delivary from "./delivary.jpg";
import contact from "./contact.jpg";
import Ken from "./Ken.jpg";
import Cinder from "./Cinder.jpg";
import Celine from "./Celine.jpg";
import DH from "./D.H.jpg";
import Elsa from "./Elsa.jpg";
import Tina from "./Tina.jpg";
import Tushy from "./Tushy.jpg";
import William from "./William.jpg";
import riverside from "./Riverside.jpg";
import carina from "./carina.jpg";
import kathryn from "./kathryn.jpg";
import antony from "./antony.jpg";
import mark from "./mark.jpg";
import matt from "./matt.jpg";
import standard from "./default.jpg";
import logo from "./logo.jpg";
import seth from "./seth.jpg";
import sn from "./S N.jpg";
import Heather from "./Heather S.jpg";
import renee from "./renee.jpg";

import sliderImg1 from "./sliderImg1.jpg";
import sliderImg2 from "./sliderImg2.jpg";
import sliderImg3 from "./sliderImg3.jpg";
import sliderImg4 from "./sliderImg4.jpg";
import sliderImg5 from "./sliderImg5.jpg";
import sliderImg6 from "./sliderImg6.jpg";
import sliderImg7 from "./sliderImg7.jpg";
import sliderImg8 from "./sliderImg8.jpg";
import sliderImg9 from "./sliderImg9.jpg";
import sliderImg10 from "./sliderImg10.jpg";

import gallery1 from "./gallery1.jpg";
import gallery2 from "./gallery2.jpg";
import gallery3 from "./gallery3.jpg";
import gallery4 from "./gallery4.jpg";
import gallery5 from "./gallery5.jpg";
import gallery6 from "./gallery6.jpg";
import gallery7 from "./gallery7.jpg";
import gallery8 from "./gallery8.jpg";
import gallery9 from "./gallery9.jpg";
import gallery10 from "./gallery10.jpg";

// Create a centralized images object
const images = {
  IvanLogo,
  afterRepair,
  beforeRepair,
  maintenance,
  maintenance2,
  business,
  emergency,
  aboutIvan,
  Installation,
  delivary,
  contact,
  Ken,
  Cinder,
  Celine,
  DH,
  Elsa,
  Tina,
  Tushy,
  William,
  riverside,
  carina,
  kathryn,
  antony,
  mark,
  matt,
  standard,
  logo,
  seth,
  sn,
  Heather,
  renee,
  sliderImg1,
  sliderImg2,
  sliderImg3,
  sliderImg4,
  sliderImg5,
  sliderImg6,
  sliderImg7,
  sliderImg8,
  sliderImg9,
  sliderImg10,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
};

// Maintain all existing named exports
export {
  IvanLogo,
  afterRepair,
  beforeRepair,
  maintenance,
  maintenance2,
  business,
  emergency,
  aboutIvan,
  Installation,
  delivary,
  contact,
  Ken,
  Cinder,
  Celine,
  DH,
  Elsa,
  Tina,
  Tushy,
  William,
  riverside,
  carina,
  kathryn,
  antony,
  mark,
  matt,
  standard,
  logo,
  seth,
  sn,
  Heather,
  renee,
  sliderImg1,
  sliderImg2,
  sliderImg3,
  sliderImg4,
  sliderImg5,
  sliderImg6,
  sliderImg7,
  sliderImg8,
  sliderImg9,
  sliderImg10,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
};

// Default export for all images as an object
export default images;
